module.exports = __webpack_public_path__ + "img/extended.ac73f950.png";